import React, { useEffect, useState } from "react";
import { message, Spin } from "antd";
import Listproducts from "./listProduct";
import Service from "./../../utils/apiOpen";
import ICDone from '../../assets/images/success.png';
import Helper from './../../utils/helper';
export const LocalState = React.createContext();

const Index = () => {
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [config, setConfig] = useState(false);

    const Status = (color, text) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.80007 5.50001C9.80007 8.15098 7.65104 10.3 5.00007 10.3C2.34911 10.3 0.200073 8.15098 0.200073 5.50001C0.200073 2.84905 2.34911 0.700012 5.00007 0.700012C7.65104 0.700012 9.80007 2.84905 9.80007 5.50001Z" fill={color} />
                </svg>
                <div style={{ color: color, margin: '0px 0px 0px 5px' }}>{text}</div>
            </div>
        )
    }

    const Breadcrumb = () => {
        switch (step) {
            case 1:
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 30, fontSize: 16, marginBottom: 30 }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => setStep(1)}>Quản lý sản phẩm</div>
                    </div>
                )
            default:
                break;
        }

    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getConfig();
    }, []);

    const getConfig = () => {
        Service.openApiCall('GET', `/v1/affiliate/portal/product/config`)
            .then((res) => {
                if (res.data.success) {
                    setConfig(res?.data?.data);
                }
            })
            .catch((err) => {
                if (err?.response) {
                    message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
                }
            });
    };

    const RenderStatus = (statusId) => {
        switch (statusId) {
            case 'dang_hoat_dong':
                return Status('#069D27', 'Đang hoạt động');
            case 'cho_kiem_duyet':
                return Status('#FFB700', 'Chờ kiểm duyệt');
            case 'ngung_hoat_dong':
                return Status('#191919', 'Ngừng hoạt động');
            default:
                break;
        }
    }

    const goStep = (page) => {
        setStep(page);
    };

    const PageView = () => {
        switch (step) {
            case 1:
                return <Listproducts />;
        }
    };

    // Thông báo lỗi dủng chung cho các page
    const MessageErr = (content) => {
        message.error(
            {
                content: content,
                style: {
                    marginTop: "25px",
                },
            },
            15
        );
    };

    const MessageSucces = (content) => {
        message.open(
            {
                content: (
                    <div style={{ textAlign: 'center' }}>
                        <img
                            src={ICDone}
                            width="35"
                        />
                        <div><b>{content}</b></div>
                    </div>
                ),
                style: {
                    marginTop: "25px",
                },
            },
            2
        );
    };

    return (
        <LocalState.Provider
            value={{
                goStep,
                step,
                MessageErr,
                MessageSucces,
                RenderStatus,
                config
            }}
        >
            <Breadcrumb />
            <div style={{ margin: "0px 5px" }}>{PageView()}</div>
        </LocalState.Provider>
    );
};

export default Index;
